// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner .banner__sheet.v-sheet {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(66, 66, 66, 0.3);\n}\n.banner .banner__link {\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n}\n.banner .banner__link:hover, .banner .banner__link:focus {\n  color: #ff7500;\n  text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
